import imgFormats from "./tools/unit/images/img"
import Regulars from "./tools/regulars/forms/forms"
import FormatString,{ getHostName } from './tools/getUrlParms.js'
import FormatStringNew from "./tools/formatString/formatString.js"
import wechats from "./tools/wechats/wechats.js";
export {
    getHostName,
    wechats,
    imgFormats,
    Regulars,
    FormatString,
    FormatStringNew
  }